import {
  Button,
  Checkbox,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Fab,
  FilledInput,
  FormControlLabel,
  FormGroup,
  TextField,
  Typography,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import { debounce, filter, isEqual, orderBy, set } from "lodash-es";
import React, { useState, useEffect, useCallback, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { FixedSizeList as List } from "react-window";
import useWindowDimensions from "../../services/useWindowDimensions";
import { matchSorter } from "match-sorter";
import { BsFillLightningChargeFill } from "react-icons/bs";
import {
  FaTimes,
  FaSearch,
  FaExclamationTriangle,
  FaStar,
  FaRegStar,
} from "react-icons/fa";
import { useParams, useHistory } from "react-router";
import Chip from "@material-ui/core/Chip";
import Tooltip from "@material-ui/core/Tooltip";
import StarIcon from "@material-ui/icons/Star";
import StarBorderIcon from "@material-ui/icons/StarBorder";
import InView, { useInView } from "react-intersection-observer";
import fetcher from "../../api/swr_fetcher";
import { useQuery } from "react-query";
import loaderGif from "../../assets/img/loader.gif";
import { useDialog } from "../../contexts/DialogProvider";
import ScrollTopButton from "../ScrollTopButton";
import FilterIconMarket from "../../assets/icons/filtericonMarket";
const CustomChip = ({ label, disabled, enabled, handleClick }) => {
  const [selected, setSelected] = useState(false);
  const [count, setCount] = useState(0);
  useEffect(() => {
    setSelected(enabled);
    if (!enabled) {
      setCount(0);
    }
  }, [enabled]);

  return (
    <Tooltip
      arrow
      enterTouchDelay={500}
      title={disabled ? "Sort is disabled while searching for coins" : ""}
      placement="bottom"
    >
      <div className={disabled && "cursor-not-allowed"}>
        <Button
          color="primary"
          disableRipple
          // variant={selected ? "contained" : "outlined"}
          size="small"
          disabled={disabled ? true : false}
          onClick={() => {
            let coinCountTemp = count + 1;
            if (coinCountTemp <= 2) {
              setSelected(true);
              handleClick(true);
              setCount(coinCountTemp);
            } else {
              setSelected(false);
              handleClick(false);
              setCount(0);
            }
          }}
          className={`p-0  normal-case  m-0 py-[2px] bg-transparent  text-xs ${
            !selected
              ? " border-0 font-normal dark:text-[#B8B9BE]  text-[#B8B9BE]"
              : "dark:text-pb-primary-100 text-pb-primary-100 font-medium"
          }`}
        >
          <span>{label}</span>
          <div className="ml-1">
            <FilterIconMarket fill={count == 1 ? "#3AC4AB" : "#B8B9BE"} />
            <div className="rotate-180 p-0 h-[10px]">
              <FilterIconMarket fill={count == 2 ? "#3AC4AB" : "#B8B9BE"} />
            </div>
          </div>
        </Button>
      </div>
    </Tooltip>
  );
};
const CurrencyPanel = React.memo(({ tab }) => {
  const classes = useStyles();

  // const coinIcons = useSelector((state) => state.trading.COIN_ICONS);
  const favIcons = useSelector((state) => state.trading.FAV_PRICES);
  const prices = useSelector((state) => state.priceReducer.PRICES, isEqual);
  const [allItems, setAllItems] = useState([]);
  const [filteredItems, setFilteredItems] = useState([]);
  const [filteredInnovationItems, setFilteredInnovationItems] = useState([]);
  const [sorting, setSorting] = useState(null);
  const [searchText, setSearchText] = useState("");
  const { height } = useWindowDimensions();
  const ref = useRef(null);

  const coinConfig = useQuery(
    ["coinConfig"],
    () => fetcher("/v1/coinConfig").then((res) => res),
    {
      onSuccess: (data) => {
        let temp = [];
        Object.keys(data).map((ele, idx) => {
          temp.push(data[ele]);
        });
        const sortedArrayByMarketCap = sort_by_key_descending(
          temp,
          "marketCap"
        );
        // const sortedArrayByMarketCap = sort_by_key_descending(
        //   tempData,
        //   "marketCap"
        // );

        const removeInactiveCoins = sortedArrayByMarketCap.filter(
          (ele) => ele.tradeStatus !== "INACTIVE" || ele.coinId == "LUNA"
        );

        //This list is fixed always
        setAllItems([...removeInactiveCoins]);
      },
    }
  );

  function sort_by_key_descending(array, key) {
    return array.sort(function (a, b) {
      var x = a[key];
      var y = b[key];
      return y - x;
    });
  }
  function sort_by_key_ascending(array, key) {
    return array.sort(function (a, b) {
      var x = a[key];
      var y = b[key];
      return x < y ? -1 : x > y ? 1 : 0;
    });
  }
  const debounceOnChange = useCallback(
    debounce((value) => {
      setSearchText(value);
    }, 500),
    []
  );

  const generateDefaultItemsBasedOnTab = (allItems, tab) => {
    let items = [];
    switch (tab) {
      case "MARKETS": {
        items = allItems;
        // filter((item) => Boolean(item?.inInnovationZone) === false);

        break;
      }
      case "INNOVATION": {
        items = filter(
          allItems,
          (item) => Boolean(item?.inInnovationZone) === true
        );
        break;
      }
      case "FAV": {
        items = allItems.filter((ele, idx) => favIcons.includes(ele.coinId));
        items = orderBy(items, ["marketCap"], ["desc"]);
        items = orderBy(items, ["inInnovationZone"], ["asc"]);

        let firstInnovationIndex = items.findIndex(function (item, i) {
          return Boolean(item.inInnovationZone) === true;
        });
        if (firstInnovationIndex == -1) {
          setFilteredInnovationItems([]);
        } else {
          let first = items.slice(0, firstInnovationIndex);
          let second = items.slice(firstInnovationIndex, items.length);
          setFilteredInnovationItems(second);
          items = first;
        }
        // items = filter(allItems, (item) => item.inInnovationZone == false);
        break;
      }
      default:
        break;
    }
    return items;
  };

  useEffect(() => {
    if (searchText.length > 0) {
      let items = matchSorter(allItems, searchText, {
        keys: ["coinId", "coinName"],
      });
      items = orderBy(items, ["marketCap"], ["desc"]);
      items = orderBy(items, ["inInnovationZone"], ["asc"]);

      let firstInnovationIndex = items.findIndex(function (item, i) {
        return Boolean(item.inInnovationZone) === true;
      });
      if (firstInnovationIndex == -1) {
        setFilteredItems(items);
        setFilteredInnovationItems([]);
      } else {
        let first = items.slice(0, firstInnovationIndex);
        let second = items.slice(firstInnovationIndex, items.length);
        setFilteredItems(first);
        setFilteredInnovationItems(second);
      }
    } else {
      let items = generateDefaultItemsBasedOnTab(allItems, tab);
      setFilteredItems(items);
    }
  }, [searchText, allItems, tab]);

  useEffect(() => {
    let items = generateDefaultItemsBasedOnTab(allItems, tab);
    setFilteredItems(items);
  }, [favIcons]);

  useEffect(() => {
    if (searchText.length == 0) {
      if (sorting) {
        let items = handleSorting(filteredItems, sorting, prices);
        setFilteredItems(items);
        items = handleSorting(filteredInnovationItems, sorting, prices);
        setFilteredInnovationItems(items);
      } else {
        let items = generateDefaultItemsBasedOnTab(allItems, tab);
        setFilteredItems(items);
      }
    }
  }, [sorting, tab, searchText]);

  const handleSearchReset = () => {
    if (ref.current) {
      ref.current.value = "";
    }
    setSearchText("");
  };

  const handleSorting = (items, sorting, prices) => {
    switch (sorting) {
      case "A-Z": {
        items = orderBy(items, ["coinId"], ["asc"]);
        break;
      }
      case "Z-A": {
        items = orderBy(items, ["coinId"], ["desc"]);
        break;
      }
      case "Price": {
        items = handlePriceSort(items, prices);
        break;
      }
      case "Pricedesc": {
        items = handlePriceSortDesc(items, prices);
        break;
      }
      case "24h": {
        items = handle24hSort(items, prices);
        break;
      }
      case "24hdesc": {
        items = handle24hSortDesc(items, prices);
        break;
      }
      default:
        break;
    }
    return items;
  };
  function handle24hSort(items, prices) {
    let valueA;
    let valueB;
    const sortedByHr = [...items].sort(function (a, b) {
      if (!prices[`${a.coinId}INR`]) {
        valueA = 0;
      } else {
        valueA = prices[`${a.coinId}INR`]["hrb"];
      }
      if (!prices[`${b.coinId}INR`]) {
        valueB = 0;
      } else {
        valueB = prices[`${b.coinId}INR`]["hrb"];
      }
      return valueA > valueB ? -1 : valueA < valueB ? 1 : 0;
    });

    return sortedByHr;
  }
  function handle24hSortDesc(items, prices) {
    let valueA;
    let valueB;
    const sortedByHrDesc = [...items].sort(function (a, b) {
      if (!prices[`${a.coinId}INR`]) {
        valueA = 0;
      } else {
        valueA = prices[`${a.coinId}INR`]["hrb"];
      }
      if (!prices[`${b.coinId}INR`]) {
        valueB = 0;
      } else {
        valueB = prices[`${b.coinId}INR`]["hrb"];
      }
      return valueA < valueB ? -1 : valueA > valueB ? 1 : 0;
    });

    return sortedByHrDesc;
  }
  function handlePriceSort(items, prices) {
    let valueA;
    let valueB;
    const sortedByPrice = [...items].sort(function (a, b) {
      if (!prices[`${a.coinId}INR`]) {
        valueA = 0;
      } else {
        valueA = prices[`${a.coinId}INR`]["a"];
      }
      if (!prices[`${b.coinId}INR`]) {
        valueB = 0;
      } else {
        valueB = prices[`${b.coinId}INR`]["a"];
      }
      return valueA > valueB ? -1 : valueA < valueB ? 1 : 0;
    });

    return sortedByPrice;
  }
  function handlePriceSortDesc(items, prices) {
    let valueA;
    let valueB;
    const sortedByPriceDesc = [...items].sort(function (a, b) {
      if (!prices[`${a.coinId}INR`]) {
        valueA = 0;
      } else {
        valueA = prices[`${a.coinId}INR`]["a"];
      }
      if (!prices[`${b.coinId}INR`]) {
        valueB = 0;
      } else {
        valueB = prices[`${b.coinId}INR`]["a"];
      }
      return valueA < valueB ? -1 : valueA > valueB ? 1 : 0;
    });

    return sortedByPriceDesc;
  }
  return (
    <div>
      <div>
        <div className="mb-2 mx-4 flex flex-col gap-y-2">
          <FilledInput
            autoComplete={"off"}
            inputRef={ref}
            id="filled-secondary"
            label="Filled secondary"
            variant="filled"
            color="primary"
            placeholder="Search coins..."
            onChange={(e) => {
              let value = e.target.value;
              setSorting(null);
              debounceOnChange(value);
            }}
            classes={{
              root: classes.root,
              input: classes.input,
            }}
            startAdornment={<FaSearch className="opacity-50 "></FaSearch>}
            endAdornment={
              searchText.length > 0 ? (
                <FaTimes
                  className="opacity-50 cursor-pointer hover:opacity-50"
                  onClick={handleSearchReset}
                ></FaTimes>
              ) : (
                <></>
              )
            }
            disableUnderline
          />
          <div className="flex items-center gap-x-2  text-xs">
            <p className="">Sort By</p>
            <CustomChip
              label="A-Z"
              disabled={searchText.length > 0}
              enabled={sorting === "A-Z" || sorting === "Z-A" ? true : false}
              handleClick={(selected) => {
                if (selected) {
                  // handleSearchReset();
                  setSorting((prev) => {
                    if (prev == null || prev !== "A-Z") {
                      return "A-Z";
                    } else {
                      return "Z-A";
                    }
                  });
                } else {
                  setSorting(null);
                }
                // if (!isSorting) {
                //   setIsSorting(true);
                // }
              }}
            />
            <CustomChip
              label="Price"
              disabled={searchText.length > 0}
              enabled={
                sorting === "Price" || sorting === "Pricedesc" ? true : false
              }
              handleClick={(selected) => {
                if (selected) {
                  // handleSearchReset();
                  setSorting((prev) => {
                    if (prev == null || prev !== "Price") {
                      return "Price";
                    } else {
                      return "Pricedesc";
                    }
                  });
                } else {
                  setSorting(null);
                }
              }}
            />
            <CustomChip
              label="24h%"
              disabled={searchText.length > 0}
              enabled={
                sorting === "24h" || sorting === "24hdesc" ? true : false
              }
              handleClick={(selected) => {
                if (selected) {
                  // handleSearchReset();
                  setSorting((prev) => {
                    if (prev == null || prev !== "24h") {
                      return "24h";
                    } else {
                      return "24hdesc";
                    }
                  });
                } else {
                  setSorting(null);
                }
              }}
            />
          </div>
        </div>

        {coinConfig.isLoading ? (
          <div className="flex justify-center mt-10">
            <img src={loaderGif} alt="loading..." width={100} />
          </div>
        ) : filteredItems?.length == 0 &&
          filteredInnovationItems?.length == 0 &&
          tab === "FAV" ? (
          <div className="text-center  flex flex-col justify-center items-center gap-y-3 mt-10">
            <StarIcon className="text-pb-yellow-100" size="30px"></StarIcon>
            <p className="opacity-50">No favourite coins found</p>
          </div>
        ) : filteredItems?.length == 0 &&
          filteredInnovationItems?.length == 0 &&
          searchText?.length > 0 ? (
          <div className="text-center opacity-50 flex flex-col justify-center items-center gap-y-3 mt-10">
            <FaExclamationTriangle size="28px" className="opacity-50" />
            <p>No coins found</p>
          </div>
        ) : (
          <>
            <div
              id="coins-list"
              className="overflow-y-auto "
              style={{ maxHeight: "calc(100vh - 180px)" }}
            >
              {/* <List
              // className="overflow-hidden"
              height={
                filteredItems.length * 45 < height - 120
                  ? filteredItems.length * 45
                  : height - 120
              }
              itemCount={filteredItems.length}
              itemSize={45}
              width={279}
              itemData={{
                items: [...filteredItems],
                favIcons: favIcons?.length > 0 ? favIcons : [],
              }}
            >
              {Row}
            </List> */}
              {filteredItems.map((ele, idx) => {
                return (
                  <Row
                    key={ele.coinId}
                    index={idx}
                    data={{
                      items: filteredItems,
                      favIcons: favIcons?.length > 0 ? favIcons : [],
                    }}
                  ></Row>
                );
              })}
              {(searchText.length > 0 || tab === "FAV") &&
                filteredInnovationItems.length > 0 && (
                  <>
                    <div className="flex bg-pb-primary-100 text-pb-primary-100 bg-opacity-20 gap-x-2 p-2 pl-5 mb-2 items-center">
                      <BsFillLightningChargeFill />
                      <h5 className="md:text-[14px] ">Innovation Zone</h5>
                    </div>

                    {filteredInnovationItems.map((ele, idx) => (
                      <Row
                        key={ele.coinId}
                        index={idx}
                        data={{
                          items: filteredInnovationItems,
                          favIcons: favIcons?.length > 0 ? favIcons : [],
                        }}
                      ></Row>
                    ))}
                  </>
                )}
            </div>

            <ScrollTopButton />
          </>
        )}
      </div>
    </div>
  );
});

const Row = React.memo(({ data, index }) => {
  const item = data.items[index];
  const [openDialog, closeDialog] = useDialog();
  const { coin } = useParams();
  const history = useHistory();
  const dispatch = useDispatch();
  const { ref, inView, entry } = useInView({
    threshold: 0,
  });

  const [image, setImage] = useState(item.activeIconUrl);

  const isFavorite = data.favIcons.includes(item.coinId);
  const doNotShow = useSelector((state) => state.trading.INNOVATION_DNS);

  const sell = useSelector(
    (state) => state.priceReducer.PRICES[`${item.coinId}INR`]?.["b"],
    isEqual
  );
  const buy = useSelector(
    (state) => state.priceReducer.PRICES[`${item.coinId}INR`]?.["a"],
    isEqual
  );
  const hour = useSelector(
    (state) => state.priceReducer.PRICES[`${item.coinId}INR`]?.["hrb"],
    isEqual
  );
  console.log(hour, "hour");
  const handleCoinClick = (item, inInnovationZone, doNotShow) => {
    if (inInnovationZone && !doNotShow) {
      openDialog({
        children: (
          <>
            <DialogTitle className="pb-0 px-5">
              <div className="flex items-center gap-x-3">
                <img src={item.activeIconUrl} width={30} alt={item.coinId} />
                <h3 className="font-semibold">
                  {item.coinId} is an{" "}
                  <span className="text-pb-primary-100">innovation zone</span>{" "}
                  token
                </h3>
              </div>
            </DialogTitle>
            <form
              required
              component="fieldset"
              onSubmit={async (e) => {
                e.preventDefault();
                if (e.target.first.checked) {
                  dispatch({
                    type: "SET_INNOVATION_DO_NOT_SHOW",
                    payload: { [item.coinId]: true },
                  });
                }

                history.push(`/trade/${item.coinId}`);
                closeDialog();
              }}
            >
              <DialogContent className="pb-0">
                <Typography className="">
                  <span className="text-pb-secondary-100">Note:</span>
                </Typography>
                <Typography className="font-light mb-4">
                  <strong>{item.coinName}</strong> is either a highly volatile
                  or a relatively new asset. Do your own research and trade with
                  caution.
                </Typography>
                <div className="w-full">
                  <FormGroup>
                    <FormControlLabel
                      control={<Checkbox name="first" color="primary" />}
                      label={
                        <p className="text-sm font-light md:text-base">
                          I understand the risks involved when trading in crypto
                          assets
                        </p>
                      }
                    />
                  </FormGroup>
                </div>
              </DialogContent>
              <DialogActions className="px-4 mb-4">
                <Button
                  disableElevation
                  className="w-full normal-case"
                  type="submit"
                  variant="contained"
                  color="primary"
                  style={{ color: "white", fontWeight: "bold" }}
                >
                  Continue to Trade
                </Button>
              </DialogActions>{" "}
            </form>
          </>
        ),
      });
    } else {
      history.push(`/trade/${item.coinId}`);
    }
  };

  useEffect(() => {
    if (item.coinId != coin) {
      setImage(item.activeIconUrl);
    }
  }, [coin]);
  function roundOff(val, decimal) {
    let pow = Math.pow(10, decimal);

    return Math.floor(val * pow) / pow;
  }
  return (buy && sell) != null ? (
    <>
      <div ref={ref}>
        <div
          onClick={() =>
            handleCoinClick(
              item,
              Boolean(item.inInnovationZone),
              Boolean(doNotShow[item.coinId])
            )
          }
          // style={style}
          className={`pt-1  cursor-pointer ${
            item.coinId == coin && "bg-pb-primary-100 bg-opacity-10"
          } transition-all hover:bg-pb-primary-100 hover:bg-opacity-10`}
        >
          <div className="flex justify-between items-center w-full pl-2 md:pr-0 pr-2">
            <div className={`flex items-center gap-x-5  `}>
              <div className="flex items-center gap-x-[6px] w-[75px] ">
                <img src={image} width={20} height={20} alt={item.coinId} />
                <h6 className="text-[#DBDBDB font-bold text-xs ">
                  {item.coinId}
                </h6>
              </div>
              <div>
                <div className="text-xs text-pb-primary-100">
                  <strong>Buy</strong>{" "}
                  <span className="font-medium text-[#DBDBDB]">{buy}</span>
                </div>
                <div className="text-xs text-pb-secondary-100">
                  <strong>Sell</strong>{" "}
                  <span className="font-medium text-[#DBDBDB]">{sell}</span>
                </div>
              </div>
            </div>
            <div className="mr-1 flex items-center gap-x-1">
              <div
                className={`text-xs font-medium ${
                  hour < 0 ? "text-pb-secondary-100" : "text-pb-primary-100"
                } `}
              >
                {(hour > 0 ? "+" : "") + roundOff(hour, 2) || 0}%
              </div>
              {isFavorite ? (
                <StarIcon
                  onClick={(e) => {
                    e.stopPropagation();
                    dispatch({
                      type: "DELETE_FAV_PRICE",
                      payload: item.coinId,
                    });
                  }}
                  className="text-pb-yellow-100 transition-all cursor-pointer"
                  size="20px"
                ></StarIcon>
              ) : (
                <StarBorderIcon
                  onClick={(e) => {
                    e.stopPropagation();

                    dispatch({
                      type: "ADD_FAV_PRICE",
                      payload: item.coinId,
                    });
                  }}
                  className="opacity-50 transition-all cursor-pointer"
                  size="20px"
                ></StarBorderIcon>
              )}
            </div>
          </div>
          <Divider className="mt-1" />
        </div>
      </div>
    </>
  ) : (
    <></>
  );
});

const useStyles = makeStyles((theme) => ({
  root: {
    borderRadius: "6px",
    width: "100%",
  },
  input: { padding: "8px 10px" },
}));

export default CurrencyPanel;
